// extracted by mini-css-extract-plugin
export default {"contentWrapper":"_1IC1O_","container":"_3mNKVj","content":"_2GR8ZB","image":"_17OoZQ"};